






















































































import {Component, Ref} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import AuthMixin from "../../mixins/auth.mixin";
import {IUser, UserLevel, UserLevels} from "shared/entities/user";
import {Api} from "shared/api";
import {Optional} from "utility-types";
import {CreateUserRequest, UpdateUserRequest} from "shared/api/routes/user";
import {BModal} from "bootstrap-vue";
import {apiHandler} from "@/services/api-handler";
import AddUser from "@/components/add-user.vue";
import EditUser from "@/components/edit-user.vue";

@Component({components: {EditUser, AddUser}})
export default class ManageUsers extends mixins(AuthMixin) {
    users: IUser[] = [];
    currentSort: keyof IUser = "firstName";
    currentDirection: "asc" | "desc" = "asc";
    currentFilters: Optional<IUser> = {};
    UserLevel = UserLevel;
    currentPage = 1;
    linesPerPage = 10;
    @Ref("add-user") addUser!: AddUser;
    @Ref("edit-user") editUserModal!: EditUser;

    get levels() {
        if (this.user?.level !== UserLevel.Admin)
            return UserLevels.filter(level => level < (this.user?.level ?? 0)).map(level => ({level, title: UserLevel[level]}));
        else
            return UserLevels.map(level => ({level, title: UserLevel[level]}));
    }

    get levelsWithBlank() {
        const levels: {level: UserLevel|null, title: string}[] = this.levels;
        levels.unshift({level: null, title: ""});
        return levels;
    }

    get userDisplay() {
        return this.users
            .filter(u => {
                for (const fk of Object.keys(this.currentFilters) as Array<keyof IUser>) {
                    const filterPropValue = this.currentFilters[fk];
                    const userPropValue = u[fk];
                    if (filterPropValue === "" || filterPropValue === null || filterPropValue === undefined) continue;
                    if (typeof userPropValue === "string" && typeof filterPropValue === "string")
                    {
                        if (!userPropValue.toLowerCase().startsWith(filterPropValue.toLowerCase())) {
                            return false;
                        }
                    }
                    else if (
                        typeof userPropValue === "object" && typeof filterPropValue === "object" &&
                        userPropValue !== null &&
                        userPropValue.hasOwnProperty("id") && filterPropValue.hasOwnProperty("id")
                    ) {
                        if (userPropValue.id !== filterPropValue.id) {
                            return false;
                        }
                    }
                    else if (userPropValue !== filterPropValue) {
                        return false;
                    }
                }
                return true;
            })
            .sort((a: IUser, b: IUser) => {
                const av = a[this.currentSort]?.toString() ?? "";
                const bv = b[this.currentSort]?.toString() ?? "";
                if (this.currentDirection === "asc") return av.localeCompare(bv);
                else return bv.localeCompare(av);
            })
            .slice((this.currentPage - 1) * this.linesPerPage, this.currentPage * this.linesPerPage);
    }

    get numPages() {
        return Math.ceil(this.userDisplay.length / this.linesPerPage);
    }

    get owners() {
        return this.users.filter(user => user.level === UserLevel.Owner);
    }

    async mounted() {
        await this.refreshUsers();
    }

    async refreshUsers() {
        this.users = await apiHandler(() => Api.user.Get());
    }

    sort(key: keyof IUser) {
        this.currentDirection = this.currentSort === key ? this.currentDirection === "asc" ? "desc" : "asc" : "asc";
        this.currentSort = key;
    }

    showAddUser() {
        this.addUser.show();
    }

    async resetCompletions(user: IUser) {
        if (!confirm(`Are you sure you want to clear ${user.firstName} ${user.lastName}'s progress?`)) {
            return;
        }

        await apiHandler(() => Api.user[user.id].reset.Post());
        alert("User has been reset.");
    }

    async deleteUser(user: IUser) {
        if (!confirm(`Are you sure you want to delete ${user.firstName} ${user.lastName}`)) return;
        await apiHandler(() => Api.user[user.id].Delete());
        alert("The user has been deleted.");
        await this.refreshUsers();
    }

    async showEditUser(user: IUser) {
        this.editUserModal.show(user);
    }

}

